"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LinkToRecordFormatter;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Chip2 = _interopRequireDefault(require("@material-ui/core/Chip"));

var _Button2 = _interopRequireDefault(require("@material-ui/core/Button"));

var _AddRounded2 = _interopRequireDefault(require("@material-ui/icons/AddRounded"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("../propTypes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

LinkToRecordFormatter.propTypes = _propTypes.EditorProps;

function LinkToRecordFormatter(_ref) {
  var row = _ref.row,
      column = _ref.column,
      isCellSelected = _ref.isCellSelected;
  var isEditable = column.isEditable,
      key = column.key,
      loadMany = column.loadMany,
      options = column.options,
      onClickAdd = column.onClickAdd,
      onClickDelete = column.onClickDelete;
  var value = row[key] || [];
  var cache = row["cache_".concat(key)];
  var relationship = (options === null || options === void 0 ? void 0 : options.relationship) || "many";
  var id = row["id"] || row["_id"];

  var _useState = (0, _react.useState)(cache || []),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var getData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof loadMany === "function")) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return loadMany(value, column);

            case 3:
              response = _context.sent;
              setData(response || []);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getData() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    getData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var handleAdd = function handleAdd(e) {
    if (typeof onClickAdd === "function") {
      onClickAdd({
        value: value,
        row: row,
        column: column,
        currentTarget: e.currentTarget,
        variant: "add"
      });
    }
  };

  var handleDelete = function handleDelete(item) {
    if (typeof onClickAdd === "function") {
      onClickDelete({
        value: value,
        item: item,
        row: row,
        column: column
      });
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    display: "flex",
    alignItems: "center",
    onClick: isEditable && isCellSelected && value.length === 0 ? handleAdd : null,
    style: {
      height: "100%",
      position: "relative"
    }
  }, relationship === "one" && value.length >= 1 || id === "create" ? null : isCellSelected && isEditable ? /*#__PURE__*/_react["default"].createElement(_Button2["default"], {
    variant: "contained",
    style: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      borderRadius: "0.25rem",
      zIndex: 1,
      padding: 0,
      marginRight: 2,
      marginLeft: -2,
      minWidth: 16,
      height: 16
    },
    onClick: handleAdd
  }, /*#__PURE__*/_react["default"].createElement(_AddRounded2["default"], {
    style: {
      fontSize: 14
    }
  })) : null, data === null || data === void 0 ? void 0 : data.map(function (item, index) {
    var primaryKey = options === null || options === void 0 ? void 0 : options.primaryKey;

    if (!primaryKey) {
      primaryKey = item.hasOwnProperty("name") ? "name" : Object.keys(item).filter(function (key) {
        return !["id", "_id"].includes(key);
      })[0] || "name";
    }

    return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
      key: index,
      size: "small",
      color: "primary",
      label: item[primaryKey] || "Unnamed",
      onDelete: isEditable && isCellSelected ? function () {
        return handleDelete(item, index);
      } : null,
      style: {
        marginRight: 2,
        backgroundColor: "blue",
        color: "white"
      }
    });
  }));
}